import { ICaseInformationModel } from "../Interfaces";

export const CaseInformationModel:ICaseInformationModel = {
    data:undefined,
    error:false,
    isLoading:false
}